import React from 'react';
export function ViewGridIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11H5a3 3 0 01-3-3V5a3 3 0 013-3h3a3 3 0 013 3v3a3 3 0 01-3 3zM5 4a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V5a1 1 0 00-1-1H5zM19 11h-3a3 3 0 01-3-3V5a3 3 0 013-3h3a3 3 0 013 3v3a3 3 0 01-3 3zm-3-7a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V5a1 1 0 00-1-1h-3zM8 22H5a3 3 0 01-3-3v-3a3 3 0 013-3h3a3 3 0 013 3v3a3 3 0 01-3 3zm-3-7a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1H5zM19 22h-3a3 3 0 01-3-3v-3a3 3 0 013-3h3a3 3 0 013 3v3a3 3 0 01-3 3zm-3-7a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1h-3z"
  }));
}